/**
 * Shared regex constants for prodServer.js and the webpack bundle (globals.js).
 *
 * This directory has package.json "type": "module" so Node can `import()` this file from
 * CommonJS (prodServer.js) while the contents stay standard ESM (`export`).
 *
 * FUDR-13245
 */

/** Pattern for one DNS label (no anchors — safe to embed in HOSTNAME_VALIDATION_REGEX). */
const HOSTNAME_LABEL_PATTERN = '[a-z0-9]([a-z0-9-]*[a-z0-9])?';

/** Per label: letters, digits, hyphens; no leading/trailing hyphen on a label. */
const HOSTNAME_LABEL_REGEX = new RegExp('^' + HOSTNAME_LABEL_PATTERN + '$');

/**
 * Full hostname: one or more labels separated by dots. Single-label hostnames match
 * this pattern; callers that need an FQDN must also enforce {@link isValidDomainString}.
 */
export const HOSTNAME_VALIDATION_REGEX = new RegExp(
  '^(' + HOSTNAME_LABEL_PATTERN + ')(\\.(' + HOSTNAME_LABEL_PATTERN + '))*$'
);

/** Canonical IPv4 pattern for deriveSubdomain() (IPs are never custom domains). */
export const IPV4_REGEX = /^(\d{1,3}\.){3}\d{1,3}$/;

/**
 * Validates a domain/FQDN string (e.g. "app.curious-d.com") for untrusted hostname input.
 *
 * Single source of truth: prodServer.js and public/index.html must stay aligned with this
 * (index.html cannot import this module — duplicate the same steps there).
 *
 * @param {string} domain
 * @returns {boolean}
 */
export function isValidDomainString(domain) {
  if (!domain || typeof domain !== 'string') return false;
  const lower = domain.toLowerCase().trim();
  if (!lower) return false;
  if (lower.length > 253) return false;
  if (lower.startsWith('.') || lower.endsWith('.')) return false;
  if (lower.includes('..')) return false;
  const parts = lower.split('.');
  if (parts.length < 2) return false;
  for (let i = 0; i < parts.length; i++) {
    const label = parts[i];
    if (!label) return false;
    if (label.length > 63) return false;
    if (!HOSTNAME_LABEL_REGEX.test(label)) return false;
  }
  return true;
}
